
import { useState, useEffect, useRef }  from 'react';
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import 'katex/dist/katex.min.css'; // Import KaTeX styles
import remarkGfm from 'remark-gfm';


function MarkdownResponseDisplay({ text, paragraphcolor }) {
  const [renderedMarkdown, setRenderedMarkdown] = useState('');
  const containerRef = useRef(null);

  useEffect(() => {
  
    const processedText = text
    setRenderedMarkdown(processedText);

    // Re-render MathJax after the markdown content is updated
    if (containerRef.current && window.MathJax) {
      window.MathJax.typesetPromise([containerRef.current]).then(() => {
        //console.log("MathJax rendered!:", text, processedText);
      }).catch((err) => console.log('Typeset failed: ' + err.message));
    }
  }, [text]);

  return (
    <div ref={containerRef} style = {{color: 'maroon'}}>
      <ReactMarkdown
        children={renderedMarkdown}
        remarkPlugins={[remarkMath, remarkGfm]}
        rehypePlugins={[rehypeKatex]}
        components={{
          // Optional: Add custom components if needed.  For example,
          // you could add a handler for 'inlineMath' or 'math'
          // to customize the rendering further.
          h1: ({ node, children }) => (
            <h1 style={{ marginLeft:'10px', color: "maroon" }}>{children}</h1>
          ),
          h2: ({ node, children }) => (
            <h2 style={{ marginLeft:'10px',color: "maroon" }}>{children}</h2>
          ),
          h3: ({ node, children }) => (
            <>
            <h3 style={{ marginLeft:'10px',color: "maroon", fontSize:'18px' }}>{children}</h3>
            </>
          ),
          h4: ({ node, children }) => (
            <h4 style={{ marginLeft:'10px', color: "maroon", fontSize:'16px' }}>{children}</h4>
          ),
        
          p: ({ node, children }) => (
            <p style={{ marginLeft:'15px',color: paragraphcolor, fontSize:'16px'}}>{children}</p>
          ),

          pre: ({ node, children }) => (
            <pre style={{ marginLeft:'30px',color: "navy",  fontSize:'16px' }}>{children}</pre>
          ),
        
          code: ({ node, children }) => (
            <code style={{ color: "navy",  fontSize:'16px' }}>{children}</code>
          ),
          strong: ({ node, children }) => (
            <strong style={{ color: "maroon", fontSize:'16px' }}>{children}</strong>
          ),
         a: ({ node, children, href }) => (
            <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>
          ),
          
          table: ({ node, children }) => (
            <table style={{ borderCollapse: 'collapse', width: '100%', margin: '10px 0' }}>
              {children}
            </table>
          ),
          th: ({ node, children }) => (
            <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2' }}>
              {children}
            </th>
          ),
          td: ({ node, children }) => (
            <td style={{ border: '1px solid black', padding: '8px', textAlign: 'left', color:'black' }}>
              {children}
            </td>
          ),
          tr: ({ node, children }) => (
            <tr>{children}</tr>
          ),
          
        }}
      />
    </div>
  );
}


MarkdownResponseDisplay.defaultProps = {
  paragraphcolor: 'black',
}

export default MarkdownResponseDisplay;



